
import { StateCreator } from "zustand";
import { SECURE_AUTH_TOKEN_KEY, SECURE_BASE_URL_KEY, AUTH_HEADER } from "../../../base";
import { getDataKeyFromLocalStorage } from "../../../common/utils/AuthToken";
import Endpoints from "../../../domain/endpoints";
import { FetchState } from "../../../domain/models/fetch-state";
import { AxiosHttpClient } from "../../../infra/http/axios-http-client";
import { FetchUserTerritoryType } from "../../../domain/models/monthly-tour-program/fetch-user-territory";
import { FetchUserTerritory } from "../../../domain/useages/monthly-tour-program/fetchUserTerritory";
import { RemoteFetchUserTerritory } from "../../../data/usecases/monthly-tour-program/remote-fetch-user-territory";

export interface FetchUserTerritoryInterface {
  FetchUserTerritory: FetchUserTerritoryType;
  FetchUserTerritoryState: FetchState;
  fetchUserTerritory: Function;
}

const initialStates = {
  FetchUserTerritory: {} as FetchUserTerritoryType,
  FetchUserTerritoryState: FetchState.DEFAULT,
};

const axiosHttpClient = AxiosHttpClient.getInstance();


export const useFetchUserTerritorySlice: StateCreator<
  FetchUserTerritoryInterface
> = (set) => ({
  ...initialStates,
  fetchUserTerritory: async (filter: FetchUserTerritory.Params) => {
  
    const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ??"";
    const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);

    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });

    const remoteFetchUserTerritory = new RemoteFetchUserTerritory(
      `${BASE_URL}${Endpoints.FETCH_USER_TERRITORY}`,
      axiosHttpClient
    );

    set(() => ({ FetchUserTerritoryState: FetchState.LOADING }));
    let result = await remoteFetchUserTerritory.fetch(filter);
    return result;
  },
});
